import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { initializeSiteConfig, tokenInterceptor } from '~/shared-common';
import { ngrxLocalFeature } from '~/shared-core/data-access';
import { errorHandlingInterceptor } from '~/shared-core/error-handler';
import { ngrxFormsEffects, ngrxFormsFeature } from '~/shared-core/forms';
import { API_URL, provideApiService } from '~/shared-core/http-client';
import { ENABLED_LOGGER } from '~/shared-core/logger';
import { environment } from '../environments/environment';
import { CustomRouteReuseStrategy } from './app.customrouter';
import { appRoutes } from './app.routes';
export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withViewTransitions(),
      withComponentInputBinding(),
      // Scroll to top on new navigations, restore position on back/forward.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    {
      provide: API_URL,
      useValue: environment.api_url,
    },
    {
      provide: ENABLED_LOGGER,
      useValue: !environment.production,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSiteConfig,
      multi: true,
    },
    provideStore({
      router: routerReducer,
      ngrxForms: ngrxFormsFeature.reducer,
      ngrxLocal: ngrxLocalFeature.reducer,
    }),
    provideEffects(ngrxFormsEffects),
    provideRouterStore(),
    provideHttpClient(
      withFetch(),
      withInterceptors([errorHandlingInterceptor, tokenInterceptor]),
    ),
    provideApiService(),
    provideAnimationsAsync(),
    !environment.production ? provideStoreDevtools() : [],
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],
};
